import { withEventBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/eventBased';

import { defaultState } from './defaultState';

export const selectors = withEventBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  groups: () => slice((state) => state.groups),
  error: () => slice((state) => state.error),
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading)
}));
